import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import validateApi from 'Users/api/validateApi';
import {changeIsTaxIdentifierValid, ValidateActionType, validateTaxIdentifier} from 'Users/ducks/validate';

function* validateTaxIdentifierApi(action: ReturnType<typeof validateTaxIdentifier>) {
  const data = yield call(validateApi.validateTaxIdentifier, action.payload.taxIdentifier);

  if (E.isRight(data)) {
    yield put(changeIsTaxIdentifierValid(true, action.payload.uniqueKey));
  } else {
    yield put(changeIsTaxIdentifierValid(false, action.payload.uniqueKey));
  }
}

function* validateIdentifierSaga() {
  yield takeLatest(ValidateActionType.VALIDATE_TAX_IDENTIFIER, validateTaxIdentifierApi);
}

export default function*() {
  yield all([validateIdentifierSaga()]);
}
